import React, { type ChangeEvent } from "react";
import { Box, Input, IconButton } from "@chakra-ui/react";
import { SearchIcon, LegacyCloseIcon } from "ui/icons";

type SearchInputProps = {
  value: string;
  onClear: () => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
};

export function SearchInput({ value, placeholder, onClear, onChange }: SearchInputProps) {
  return (
    <Box position="relative" bg="white" pt="small">
      <SearchIcon
        color="new.gray.500"
        position="absolute"
        boxSize="icon.lg"
        top="50%"
        left="smaller"
        pointerEvents="none"
        zIndex={100}
      />
      <Input
        value={value}
        type="search"
        placeholder={placeholder}
        size="lg"
        w="100%"
        p="18px"
        pl="48px"
        _focusVisible={{ outline: "none", boxShadow: "outline", borderColor: "transparent" }}
        sx={{
          // Hide default cancel button and use our own instead
          "&::-webkit-search-cancel-button": {
            display: "none",
          },
        }}
        onChange={onChange}
      />

      <IconButton
        aria-label="Clear search"
        icon={<LegacyCloseIcon />}
        variant="unstyled"
        color="brand.textSecondary.light"
        cursor="pointer"
        position="absolute"
        boxSize={6}
        minW="auto"
        mt={2.5}
        top="50%"
        bottom="50%"
        transform="translateY(-50%)"
        right={4}
        opacity={value === "" ? 0 : 1}
        transition="all 0.1s ease-in-out"
        onClick={onClear}
      />
    </Box>
  );
}
